export const API_ERROR = 'API_ERROR'
export const CUSTOMER_COOKIE = 'MANAGEMENT_CUSTOMER_COOKIE'
export const FETCH_CURRENT_USER = 'FETCH_CURRENT_USER'
export const EXPORT = 'EXPORT'
export const CLEAR_EXPORT = 'CLEAR_EXPORT'
